<div class="main_box">
  <div class="header_line">
    <ion-icon name="dp-close" (click)="dismiss()"></ion-icon>
  </div>
  <img *ngIf="image" [src]="image">
  <div *ngIf="parsedJson" class="control">
    <pre>{{ parsedJson | json }}</pre>
  </div>
</div>